import { REACH_GOAL_TYPES, ymPushEvent, ymPushParams, ymPushWithUrl } from '@fttb/common';
export var sendParamsWithField = function sendParamsWithField(data) {
  ymPushParams({
    fttb_order_short: data
  });
};
export var sendActionBarClickYm = function sendActionBarClickYm(isConvergent) {
  var keyName = isConvergent ? REACH_GOAL_TYPES.ConvergentTariffConnect : REACH_GOAL_TYPES.HomeTariffConnect;
  ymPushEvent(keyName, {
    URL: window.location.href
  });
};
export var sendActionBarClickOnPhoneYm = function sendActionBarClickOnPhoneYm(_ref) {
  var isConvergent = _ref.isConvergent,
    data = _ref.data;
  sendParamsWithField(data);
  var keyName = isConvergent ? REACH_GOAL_TYPES.ConvergentPhoneClick : REACH_GOAL_TYPES.HomeTariffPhoneClick;
  ymPushWithUrl(keyName);
};